import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** The one mobile rule the whole app uses, the same as the server's: ten digits starting 6-9, with
 *  +91, leading zeros, spaces and dashes forgiven. */
export function isMobile(raw) {
  let digits = String(raw ?? "").replace(/\D/g, "").replace(/^0+/, "");
  if (digits.length > 10 && digits.startsWith("91")) digits = digits.slice(2).replace(/^0+/, "");
  return /^[6-9]\d{9}$/.test(digits);
}
